import { render, staticRenderFns } from "./label-tag-produce-modal.vue?vue&type=template&id=7cbb37c0&"
import script from "./label-tag-produce-modal.vue?vue&type=script&lang=js&"
export * from "./label-tag-produce-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports